import _extends from 'babel-runtime/helpers/extends';

// 相关信息 - 弹出框
import CrmRelative from '@/components/CreateCom/CrmRelative';
import RelatedBusinessCell from '@/views/oa/components/RelatedBusinessCell';

import { mapGetters } from 'vuex';

export default {
  name: 'RelatedBusiness',
  components: {
    CrmRelative: CrmRelative,
    RelatedBusinessCell: RelatedBusinessCell
  },
  props: {
    marginLeft: {
      type: String,
      default: '20px'
    },
    // 编辑时传递所有关联数据   关联联系人-contacts 关联客户-customer 商机-business 合同-contract
    allData: {
      type: Object,
      default: function _default() {
        return {
          contacts: [],
          customer: [],
          business: [],
          contract: []
        };
      }
    },
    // 展示取消关联
    showFoot: {
      type: Boolean,
      default: true
    },
    showAdd: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      showTypes: ['customer', 'contacts', 'business', 'contract'],
      showPopover: false,
      relevanceAll: {
        customerIds: [],
        contractIds: [],
        contactsIds: [],
        businessIds: []
      },
      // 相关信息信息
      relatedListData: {},
      showRelative: false
    };
  },

  computed: _extends({}, mapGetters(['crm']), {
    showCRMPermission: function showCRMPermission() {
      return this.crm;
    }
  }),
  watch: {
    allData: function allData() {
      this.relatedListData = this.allData;
    }
  },
  mounted: function mounted() {
    // 编辑时勾选
    this.relatedListData = this.allData;
  },

  methods: {
    crmrelativeClose: function crmrelativeClose() {
      this.showPopover = false;
    },
    checkInfos: function checkInfos(val) {
      var _this = this;

      this.showPopover = false;
      this.relatedListData = val.data;

      var _loop = function _loop(key) {
        var list = val.data[key];
        _this.relevanceAll[key + 'Ids'] = list.map(function (item) {
          return item[key + '_id'];
        });
      };

      for (var key in val.data) {
        _loop(key);
      }
      this.$emit('checkInfos', this.relevanceAll, val.data);
    },

    // 任务页面取消关联
    delRelevance: function delRelevance(field, index, item) {
      this.$emit('unbind', field, item, index);
    },
    checkRelatedDetail: function checkRelatedDetail(field, val) {
      val.key = val[field + 'Id'] || val.id;
      this.$emit('checkRelatedDetail', field, val);
    }
  }
};